import { render, staticRenderFns } from "./CurrentNews.vue?vue&type=template&id=040d7468&scoped=true&"
import script from "./CurrentNews.vue?vue&type=script&lang=js&"
export * from "./CurrentNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040d7468",
  null
  
)

export default component.exports